enum NotificationModalTypes {
    RECONNECT_DEVICE,
}

export default NotificationModalTypes;
